import React from 'react';
import { useSelector } from 'react-redux';

import CustomerLinkCell from 'components/ReactTable/CellRenderers/CustomerLinkCell';
import AccountLinkCell from 'components/ReactTable/CellRenderers/AccountLinkCell';
import DateFilter from 'components/ReactTable/Filters/DateFilter';

const whsManagementColumnDefs = () => [
  {
    Header: 'Date From',
    accessor: 'dateFrom',
    className: 'col-6p5',
    Filter: DateFilter,
    sortIconId: 'sort-date-from',
    filterIconId: 'filter-icon-date-from',
    filterTextFieldId: 'filter-text-field-date-from'
  },
  {
    Header: 'Date To',
    accessor: 'dateTo',
    className: 'col-6p5',
    Filter: DateFilter,
    sortIconId: 'sort-date-to',
    filterIconId: 'filter-icon-date-to',
    filterTextFieldId: 'filter-text-field-date-to'
  },
  {
    Header: 'Status',
    accessor: 'published',
    className: 'col-5p',
    sortIconId: 'sort-published',
    filterIconId: 'filter-icon-published',
    filterTextFieldId: 'filter-text-field-published'
  },
  {
    Header: 'WHS Name',
    accessor: 'whsName',
    disableFilters: true,
    disableSortBy: true,
    className: 'col-10p'
  },
  {
    Header: 'Customer',
    accessor: 'customer',
    Cell: (cellInfo) => {
      const { row: { original } } = cellInfo;
      return (<CustomerLinkCell dataKey="customerDbId" data={ original } permissions={ useSelector(state => state.auth.permissions) } />);
    },
    className: 'col-15p',
    sortIconId: 'sort-customer',
    filterIconId: 'filter-icon-customer',
    filterTextFieldId: 'filter-text-field-customer'
  },
  {
    Header: 'Account',
    accessor: 'account',
    Cell: (cellInfo) => {
      const { row: { original } } = cellInfo;
      return (<AccountLinkCell dataKey="accountId" data={ original } permissions={ useSelector(state => state.auth.permissions) } />);
    },
    className: 'col-15p',
    sortIconId: 'sort-account',
    filterIconId: 'filter-icon-account',
    filterTextFieldId: 'filter-text-field-account'
  },
  {
    Header: 'Allocation',
    accessor: 'allocation',
    disableFilters: true,
    disableSortBy: true,
    className: 'col-5p'
  },
  {
    Header: 'Forms Missing',
    accessor: 'missing',
    disableFilters: true,
    disableSortBy: true,
    className: 'col-10p'
  },
  {
    Header: 'Forms Invalid',
    accessor: 'invalid',
    disableFilters: true,
    disableSortBy: true,
    className: 'col-10p'
  },
  {
    Header: 'Forms In Review',
    accessor: 'review',
    disableFilters: true,
    disableSortBy: true,
    className: 'col-10p'
  }
];

export default whsManagementColumnDefs;
